/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Error_LoadInputs */

const en_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load data. Please try again.`)
};

const de_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten konnten nicht geladen werden. Bitte versuche es erneut.`)
};

const fr_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les donnees. Veuillez reessayer.`)
};

const es_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los datos. Intentalo de nuevo.`)
};

const it_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i dati. Riprova.`)
};

const nl_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens konden niet worden geladen. Probeer het opnieuw.`)
};

const pl_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udalo sie zaladowac danych. Sprobuj ponownie.`)
};

const fi_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietojen lataaminen epaonnistui. Yrita uudelleen.`)
};

const da_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indlaese data. Proev venligst igen.`)
};

const sv_interview_error_load = /** @type {(inputs: Interview_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte ladda data. Foersoek igen.`)
};

/**
* | output |
* | --- |
* | "Failed to load data. Please try again." |
*
* @param {Interview_Error_LoadInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_error_load = /** @type {((inputs?: Interview_Error_LoadInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Error_LoadInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_error_load(inputs)
	if (locale === "fr") return fr_interview_error_load(inputs)
	if (locale === "es") return es_interview_error_load(inputs)
	if (locale === "it") return it_interview_error_load(inputs)
	if (locale === "nl") return nl_interview_error_load(inputs)
	if (locale === "pl") return pl_interview_error_load(inputs)
	if (locale === "fi") return fi_interview_error_load(inputs)
	if (locale === "da") return da_interview_error_load(inputs)
	if (locale === "sv") return sv_interview_error_load(inputs)
	return en_interview_error_load(inputs)
});